import React from "react";
import { connect } from "react-redux";
import { SetDay, findBlockedDay } from "../store";
import moment from "moment";

/**
 * Have three props needed to validate
 * date   - date to lookup
 * type   - type to lookup
 * parent - type to require
 */
export const DateElement = connect((state, ownProps) => ({
    active: state.days[ownProps.date][ownProps.type],
    disabled: ownProps.parent == null ? false : !(state.days[ownProps.date][ownProps.parent])
}), (dispatch, ownProps) => ({
    setDate: (v) => dispatch(SetDay(ownProps.date, ownProps.type, v, ownProps.parent == null && v == false))
}))(
    function DateElement(props) {
        return <td className={props.parent == null ? "clock" : "extra"}><input type="checkbox"
            name={`booked-date[${props.type}][]`}
            value={props.date}
            checked={props.active}
            onChange={() => props.setDate(!props.active)}
            disabled={props.disabled}
            id={`date-${props.type}-${props.date}`}
        />
        <label htmlFor={`date-${props.type}-${props.date}`}>{moment(props.date).format("D")}<br/>{moment(props.date).format("MMM")}</label>
        </td>
    }
)

//TODO WRAP IN CONNECT, COPY DATEELEMENT BUT USE ARRAYS OF DATES AND A TYPE.
export const DateAllElement = connect((state, ownProps) => {
    const filteredDates = ownProps.dates.filter( d => new Date(d) > ownProps.now );
    return (
        {
            dates: filteredDates,
            active: filteredDates.map(d => state.days[d][ownProps.type]).reduce((a, b) => a && b, true),
            disabled: ownProps.parent == null ? false : !filteredDates.map(d => state.days[d][ownProps.parent]).reduce((a, b) => a && b, true)
        }
    );
}, (dispatch, ownProps) => ({
    setAll: (v) => {
        ownProps.dates.filter( d => new Date(d) > ownProps.now ).map(d => {
            dispatch(SetDay(d, ownProps.type, v, ownProps.parent == null && v == false))
        });
    }
}))(function DateAllElement(props) {
    var ourDates = props.dates;
    if (new Date(ourDates[ourDates.length - 1]) > props.now) {
        return <td className="all">
            <input type="checkbox"
                disabled={props.disabled}
                checked={props.active}
                onChange={() => props.setAll(!props.active)}
                id={"date-all-" + props.type + "-" + ourDates[0]}
            />
            <label htmlFor={"date-all-" + props.type + "-" + ourDates[0]}></label>
        </td>
    } else {
        return <td className="all"></td>
    }
}
)
/**
 * dates - dates
 * day - string
 * now - time now to check
 */
export function DateSelectElement(props) {
    var d = props.dates.find(e => new Date(e).format("D") == props.day)
    var thisDate = new Date(d);
    if (d !== undefined && thisDate > props.now) {
        return <DateElement key={props.day} {...props} date={d} />;
    } else if (d == undefined) {
        let m = getMonday(props.dates[0]);
        m.setDate(m.getDate() + props.idx);
        let blocked = findBlockedDay(m);
        return <td key={props.day} className="unavailable"><input type="checkbox" disabled />
                <label data-tooltip={blocked ? blocked.desc : "Unavailable"}>&nbsp;</label>
            </td>
    } else {
        return <td key={props.day} className="unavailable"><input type="checkbox" disabled />
            <label data-tooltip="Unavailable">&nbsp;&lsquo;</label>
        </td>
    }
}

export function getMonday(d) {
    d = new Date(d);
    var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
    return new Date(d.setDate(diff));
}


// WEBPACK FOOTER //
// ./flexi/weektable/dateElement.jsx